var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row-btns" },
    [
      _vm._l(_vm.normalBtns, function (item, index) {
        return [
          item.permission
            ? _c("el-button", {
                directives: [
                  {
                    name: "FPermission",
                    rawName: "v-FPermission",
                    value: item.permission,
                    expression: "item.permission",
                  },
                ],
                key: index,
                staticClass: "t-square-btn",
                attrs: {
                  type: "primary",
                  size: "mini",
                  icon: item.icon,
                  circle: "",
                },
                on: {
                  click: function ($event) {
                    return _vm.handleClick(item.type)
                  },
                },
              })
            : _c(
                "el-button",
                {
                  key: index,
                  staticClass: "t-square-btn",
                  attrs: {
                    type: "primary",
                    size: "mini",
                    icon: item.icon,
                    circle: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleClick(item.type)
                    },
                  },
                },
                [_vm._v(_vm._s(item.txt))]
              ),
        ]
      }),
      _vm._v(" "),
      _vm.otherBtns.length > 0
        ? _c(
            "el-dropdown",
            { attrs: { trigger: "click", size: "medium" } },
            [
              _c("el-button", {
                staticClass: "t-square-btn t-more-btn",
                attrs: {
                  type: "danger",
                  size: "mini",
                  icon: "el-icon-more",
                  circle: "",
                },
              }),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _vm._l(_vm.otherBtns, function (item, index) {
                    return [
                      item.permission
                        ? _c(
                            "el-dropdown-item",
                            {
                              directives: [
                                {
                                  name: "FPermission",
                                  rawName: "v-FPermission",
                                  value: item.permission,
                                  expression: "item.permission",
                                },
                              ],
                              key: index,
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.handleClick(item.type)
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.txt))]
                          )
                        : _c(
                            "el-dropdown-item",
                            {
                              key: index,
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.handleClick(item.type)
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.txt))]
                          ),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }